function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MULTIPLE_NOTES_ADD_APPLICATION_ID, MULTIPLE_NOTES_CLEAR_APPLICATION_IDS, MULTIPLE_NOTES_HIDE, MULTIPLE_NOTES_REMOVE_APPLICATION_ID, MULTIPLE_NOTES_SET_APPLICATION_IDS, MULTIPLE_NOTES_SET_NOTE, MULTIPLE_NOTES_SET_TEMPLATE_ID, MULTIPLE_NOTES_SET_VISIBLE, MULTIPLE_NOTES_SHOW, MULTIPLE_NOTES_UNSET_NOTE, MULTIPLE_NOTES_UNSET_TEMPLATE_ID, NOTE_TEMPLATES_FILTER_CLEAR, NOTE_TEMPLATES_FILTER_SET_ARCHIVED, NOTE_TEMPLATES_FILTER_SET_CATEGORIES, NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS, NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS, NOTE_TEMPLATES_FILTER_SET_HIDDEN, NOTE_TEMPLATES_FILTER_SET_RESTRICTED, NOTE_TEMPLATES_FILTER_SET_SEARCH, NOTE_TEMPLATES_FILTER_SET_TAGS, NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES, NOTE_TEMPLATES_FILTER_SET_VISIBILITY, NOTE_TEMPLATES_FILTER_SET_VISIBLE, NOTE_TEMPLATES_FILTER_TOGGLE, SET_NOTE_TEMPLATES, SET_NOTE_TEMPLATES_CATEGORIES_LOADING, SET_NOTE_TEMPLATE_CATEGORIES, SET_NOTE_TEMPLATE_VARIABLES, SET_RENDERED_NOTE_TEMPLATE_ERROR, SET_RENDERED_NOTE_TEMPLATE_IS_LOADING, SET_RENDERED_NOTE_TEMPLATE_RECEIVED } from "../actions/note_templates";
var DEFAULT_TEMPLATE_TYPE = 'admin';
var defaultState = {
  isLoaded: false,
  isLoading: false,
  templates: {},
  categories: [],
  variables: [],
  rendered_template_is_loading: false,
  rendered_template_error: false,
  rendered_template_id: null,
  rendered_template_application_id: null,
  rendered_template_response: null,
  filter_visible: false,
  filter_search: '',
  filter_categories: [],
  filter_tags: [],
  filter_for_agents: false,
  filter_for_students: false,
  filter_restricted: false,
  filter_archived: 'false',
  filter_template_types: [DEFAULT_TEMPLATE_TYPE],
  multiple_notes_modal_visible: false,
  multiple_notes_selected_template_id: null,
  multiple_notes_selected_note: null,
  multiple_notes_application_ids: []
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  // eslint-disable-next-line default-case
  switch (action.type) {
    case SET_NOTE_TEMPLATES:
      return _objectSpread(_objectSpread({}, state), {}, {
        templates: action.value,
        isLoaded: true,
        isLoading: false
      });
    case SET_NOTE_TEMPLATES_CATEGORIES_LOADING:
      if (state.isLoading === action.value) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.value
      });
    case SET_NOTE_TEMPLATE_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        categories: action.value
      });
    case SET_NOTE_TEMPLATE_VARIABLES:
      return _objectSpread(_objectSpread({}, state), {}, {
        variables: action.value
      });
    case SET_RENDERED_NOTE_TEMPLATE_IS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        rendered_template_is_loading: true,
        rendered_template_id: action.template_id,
        rendered_template_application_id: action.application_id,
        rendered_template_response: null,
        rendered_template_error: false
      });
    case SET_RENDERED_NOTE_TEMPLATE_RECEIVED:
      if (action.template_id !== state.rendered_template_id || action.application_id !== state.rendered_template_application_id) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        rendered_template_is_loading: false,
        rendered_template_response: action.value,
        rendered_template_error: false
      });
    case SET_RENDERED_NOTE_TEMPLATE_ERROR:
      if (action.template_id !== state.rendered_template_id || action.application_id !== state.rendered_template_application_id) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        rendered_template_is_loading: false,
        rendered_template_response: action.value,
        rendered_template_error: true
      });
    case NOTE_TEMPLATES_FILTER_SET_VISIBILITY:
      if (state.filter_visible !== !!action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_visible: !!action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_VISIBLE:
      if (state.filter_visible) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_visible: true
      });
    case NOTE_TEMPLATES_FILTER_SET_HIDDEN:
      if (!state.filter_visible) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_visible: false
      });
    case NOTE_TEMPLATES_FILTER_TOGGLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_visible: !state.filter_visible
      });
    case NOTE_TEMPLATES_FILTER_SET_SEARCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_search: action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_categories: action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_TAGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_tags: action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_template_types: action.value
      });
    case NOTE_TEMPLATES_FILTER_CLEAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_search: '',
        filter_categories: [],
        filter_tags: []
      });
    case NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_for_agents: action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_for_students: action.value
      });
    case NOTE_TEMPLATES_FILTER_SET_RESTRICTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_restricted: action.value
      });
    case MULTIPLE_NOTES_SHOW:
      if (state.multiple_notes_modal_visible) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_modal_visible: true
      });
    case MULTIPLE_NOTES_HIDE:
      if (!state.multiple_notes_modal_visible) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_modal_visible: false
      });
    case MULTIPLE_NOTES_SET_VISIBLE:
      if (state.multiple_notes_modal_visible === action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_modal_visible: action.value
      });
    case MULTIPLE_NOTES_SET_NOTE:
      if (state.multiple_notes_selected_note === action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_selected_template_id: null,
        multiple_notes_selected_note: action.value
      });
    case MULTIPLE_NOTES_UNSET_NOTE:
      if (state.multiple_notes_selected_note === action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_selected_note: null
      });
    case MULTIPLE_NOTES_SET_TEMPLATE_ID:
      if (state.multiple_notes_selected_template_id === action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_selected_note: null,
        multiple_notes_selected_template_id: action.value
      });
    case MULTIPLE_NOTES_UNSET_TEMPLATE_ID:
      if (state.multiple_notes_selected_template_id === null) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_selected_template_id: null
      });
    case MULTIPLE_NOTES_SET_APPLICATION_IDS:
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_application_ids: action.value
      });
    case MULTIPLE_NOTES_ADD_APPLICATION_ID:
      if (state.multiple_notes_application_ids.indexOf(action.value) >= 0) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_application_ids: state.multiple_notes_application_ids.concat(action.value)
      });
    case MULTIPLE_NOTES_REMOVE_APPLICATION_ID:
      if (state.multiple_notes_application_ids.indexOf(action.value) < 0) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_application_ids: state.multiple_notes_application_ids.filter(function (e) {
          return e !== action.value;
        })
      });
    case MULTIPLE_NOTES_CLEAR_APPLICATION_IDS:
      if (state.multiple_notes_application_ids.length <= 0) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        multiple_notes_application_ids: []
      });
    case NOTE_TEMPLATES_FILTER_SET_ARCHIVED:
      if (state.filter_archived === action.value) break;
      return _objectSpread(_objectSpread({}, state), {}, {
        filter_archived: action.value
      });
  }
  return state;
};
export default reducer;